/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaCarouselFragment} from '@amblique/contentful/app/contentful/fragments/media-carousel/base-media-carousel.fragment';
import {BaseCarouselItemFragment} from '@amblique/contentful/app/contentful/fragments/carousel-item/base-carousel-item.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const MediaCarouselFragment = gql`
  ${BaseCarouselItemFragment}
  ${BaseImageFragment}
  ${BaseMediaCarouselFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseVideoFragment}

  fragment MediaCarouselFragment on MediaCarousel {
    ...BaseMediaCarouselFragment

    imagesCollection {
      items {
        __typename
        ... on CarouselItem {
          ...BaseCarouselItemFragment
        }
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
    thumbnailsCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on Video {
          ...BaseVideoFragment
        }
      }
    }
  }
`;
